export default "__VITE_ASSET__C$JzPj8R__"